import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

export interface CustomerCvrLookupResult {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  postal_code?: string | null;
  city?: string | null;
}

export function normalizeDanishCvr(value: unknown): string | null {
  const digits = String(value ?? '').replace(/\D/g, '');
  return /^\d{8}$/.test(digits) ? digits : null;
}

export function fetchCustomerByCvr(
  http: HttpClient,
  apiUrl: string,
  cvr: string
): Observable<CustomerCvrLookupResult> {
  return http.get<CustomerCvrLookupResult>(
    `${apiUrl}/organizations/customers/cvr-lookup`,
    { params: { cvr } }
  );
}

export function applyCustomerCvrLookup(
  form: FormGroup,
  data: CustomerCvrLookupResult
): boolean {
  const patch: Record<string, string> = {};
  if (data.name?.trim()) patch['name'] = data.name.trim();
  if (data.email?.trim()) patch['email'] = data.email.trim();
  if (data.phone?.trim()) patch['phone'] = data.phone.trim();
  if (data.address?.trim()) patch['address'] = data.address.trim();
  if (data.postal_code?.trim()) patch['postal_code'] = data.postal_code.trim();
  if (data.city?.trim()) patch['city'] = data.city.trim();

  if (Object.keys(patch).length === 0) {
    return false;
  }
  form.patchValue(patch);
  return true;
}
